import React from 'react'

const AddLeads = () => {
  return (
    <div className="p-4 bg-[#ffffff]">AddLeads</div>
  )
}

export default AddLeads